type Props = {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
};

export default function SectionHeading({ eyebrow, title, description, align = "left" }: Props) {
  return (
    <div className={align === "center" ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
      {eyebrow && (
        <p className="flex items-center gap-2 font-label text-xs font-semibold uppercase tracking-wide text-primary-700">
          {align === "left" && <span className="h-px w-6 bg-primary-400" />}
          {align === "center" && <span className="mx-auto inline-block h-px w-6 bg-primary-400" />}
          {eyebrow}
        </p>
      )}
      <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {description && (
        <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{description}</p>
      )}
    </div>
  );
}